import 'remove-focus-outline'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
// import Turbolinks from 'turbolinks'
import retina from 'retinajs'

const application = Application.start()
const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context))

/*
Turbolinks.start()

document.addEventListener('turbolinks:load', function() {
  retina()
})
*/

retina()
